module.exports = __webpack_public_path__ + "img/8c2b9a6.jpg";